import { call, put, takeEvery } from 'redux-saga/effects';
import { CHANGE_USER_ADDRESS_REQUEST } from '../../constants/user_address.constants';
import { changeUserAddress } from '../../../requests/user_addresses_requests/change_user_addresses_request';
import { changeUserAddressRequestSuccess, changeUserAddressRequestFailure } from '../../actions/user_addresses_actions/common_export';
import { message_success, message_error } from '../../../../../../components/Message';

function* changeUserAddressRequest({
    user_id, country, city, street, zip_code, state, address_id,
}) {
    const {
        result, options, msg, error,
    } = yield call(changeUserAddress, country, city, street, zip_code, state, user_id, address_id);
    if (result) {
        yield put(changeUserAddressRequestSuccess(options.person.addresses));
        message_success('Address changed successfully!');
    } else {
        yield put(changeUserAddressRequestFailure(error));
        message_error(msg);
    }
}

export default function* changeUserAddressSaga() {
    yield takeEvery(CHANGE_USER_ADDRESS_REQUEST, changeUserAddressRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_addresses_sagas/change_user_address.saga.js